export default "__VITE_ASSET__BsE3_ZFt__"